<template>
  <div class="app grid-y grid-frame grid-container full">
    <mobile-topbar class="cell" v-if="isMobile()" />
    <template v-else>
      <topbar class="cell" />
      <navbar />
    </template>
    <main-content class="cell auto" />
  </div>
</template>

<script lang="ts">
import MainContent from '@/components/App/MainContent.vue'
import Navbar from '@/components/App/Navbar'
import Topbar from '@/components/App/Topbar.vue'
import MobileTopbar from '@/components/App/MobileTopbar.vue'
import { isMobile } from '@/router/utils'
import { defineComponent } from 'vue'
import { useAuthStore } from './stores/auth/authStore'
import { useOrganizationsStore } from './stores'

export default defineComponent({
  components: {
    Topbar,
    Navbar,
    MainContent,
    MobileTopbar,
  },
  setup() {
    const { whenAuthenticated } = useAuthStore()
    const { loadOrganizationsList } = useOrganizationsStore()

    whenAuthenticated().then(async () => {
      await loadOrganizationsList()
    })

    return {
      isMobile,
    }
  },
})
</script>

<style lang="scss" scoped>
.app {
  width: 100vw;
  height: 100vh;
}
</style>
